import { useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import bg from "../../../assets/man-gold.png"
export const CategoryGrid = () => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isXLarge = useMediaQuery(theme.breakpoints.up("xl"));
  const isMedium = useMediaQuery(theme.breakpoints.up("md"));
  const heroHeight = isLarge ? "60vh" : isMedium ? "50vh" : "37vh";
  const bgPosition = isLarge ? "top" : isMedium ?"65% bottom" : "65% bottom";
  return (
    <section className=" px-0 ">
     {isLarge?( <div
        className="
          py-4
          px-4
          grid gap-3
          grid-cols-12 grid-rows-12 lg:h-[70vh] xl:h-[80vh]
        "
      >
        {/* 1 */}
        <div className="aspect-square overflow-hidden rounded-md shadow-sm lg:aspect-auto lg:col-span-3 lg:row-span-12">
          <img
            src="https://cdn.pixabay.com/photo/2024/08/24/05/02/woman-8993222_1280.jpg"
            alt=""
            loading="lazy"
            className="block h-full w-full object-cover object-center"
          />
        </div>

        {/* 2 */}
        <div className="aspect-square overflow-hidden rounded-md shadow-sm lg:aspect-auto lg:col-span-3 lg:row-span-7">
          <img
            src="https://cdn.pixabay.com/photo/2013/09/01/18/12/womens-shoes-178163_1280.jpg"
            alt=""
            loading="lazy"
            className="block h-full w-full object-cover object-top"
          />
        </div>

        {/* 3 */}
        <div className="aspect-square overflow-hidden rounded-md shadow-sm lg:aspect-auto lg:col-span-3 lg:row-span-6">
          <img
            src="https://cdn.pixabay.com/photo/2014/07/31/23/00/wristwatch-407096_1280.jpg"
            alt=""
            loading="lazy"
            className="block h-full w-full object-cover object-center"
          />
        </div>

        {/* 4 */}
        <div className="aspect-square overflow-hidden rounded-md shadow-sm lg:aspect-auto lg:col-span-3 lg:row-span-12">
          <img
            src="https://cdn.pixabay.com/photo/2018/10/10/14/24/jacket-3737406_1280.jpg"
            alt=""
            loading="lazy"
            className="block h-full w-full object-cover object-top"
          />
        </div>

        {/* 5 */}
        <div className="aspect-square overflow-hidden rounded-md shadow-sm lg:aspect-auto lg:col-span-3 lg:row-span-6">
          <img
            src="https://cdn.pixabay.com/photo/2018/10/13/05/23/shoe-3743507_1280.jpg"
            alt=""
            loading="lazy"
            className="block h-full w-full object-cover object-top"
          />
        </div>

        {/* 6 */}
        <div className="aspect-square overflow-hidden rounded-md shadow-sm lg:aspect-auto lg:col-span-3 lg:row-span-6">
          <img
            src="https://images.unsplash.com/photo-1574258495973-f010dfbb5371?q=80&w=2340&auto=format&fit=crop"
            alt=""
            loading="lazy"
            className="block h-full w-full object-cover object-bottom"
          />
        </div>
      </div>):(<>
        <section
  style={{
    backgroundImage: `url(${bg})`,
    backgroundSize:  'cover',
    backgroundPosition:bgPosition, 
    width:'100%',
    height: heroHeight,
    backgroundRepeat:'no-repeat',
    objectFit:'contain'
  }}
>
  <div className="flex flex-col justify-center  items-left  text-white  h-full px-5 space-y-2">
 <h1 className="bold text-xl md:text-2xl   text-gray-700 font-bold lg:text-4xl">Empower Your Online Store</h1>
 <p className=" text-sm md:text-md lg:text-xl w-[50%] italic">Join a marketplace built for sellers who want to grow fast, sell smarter, and build a trusted brand.
Start your online store in minutes — no tech skills required.</p>
  </div>
</section>
      </>)}
    </section>
  );
};
